import { useContext } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import sparklLogoWhite from '../../assets/images/sparklLogoWhite.png';
import { ThemeContext } from '../../globalContext/theme/themeProvider';
import { SPARKL } from '../../consts/constants';
import { styles } from './PoweredBySparklStyles';

export interface PoweredBySparklProps {
  onDarkBackground?: boolean;
}

const PoweredBySparkl = ({
  onDarkBackground = false,
}: PoweredBySparklProps) => {
  const [themeState] = useContext(ThemeContext);
  const theme = useTheme();

  if (themeState?.brand?.key !== 'hale') {
    return null;
  }

  const classes = styles(theme, onDarkBackground);

  return (
    <Box className="powered-by-sparkl" sx={classes.container}>
      <Typography component="span" sx={classes.text}>
        Powered by
      </Typography>
      <Box
        component="img"
        src={onDarkBackground ? sparklLogoWhite : SPARKL.headerLogoBlack}
        alt="Sparkl"
        sx={classes.logo}
      />
    </Box>
  );
};

export default PoweredBySparkl;
